import type { OfferingLike } from "@nodus/ui";
import { Cpu, Gpu } from "lucide-react";

export function HardwareIcon({ offering }: { offering: OfferingLike }) {
  if (offering.spec?.category === "CPU") return <Cpu className="size-5 shrink-0 text-fg-muted" aria-hidden />;
  if (offering.spec?.accelerator?.vendor?.toLowerCase() === "nvidia") {
    return <img src="/model-publishers/nvidia-color.svg" alt="" width={20} height={20} className="size-5 shrink-0" />;
  }
  return <Gpu className="size-5 shrink-0 text-fg-muted" aria-hidden />;
}
